module.exports = __webpack_public_path__ + "assets/img/1.d371e8ab.png";